import { Card, Separator, Shimmer } from '@betterment/samba-react';

import { ListRowLoader } from './list-row-loader';

const TEXT_LONG_LENGTH = 176;

export function CardLoader() {
  return (
    <Card aria-label="Loading" role="status">
      <Card.Header css={{ padding: 'space.300' }}>
        <Shimmer css={{ height: '18px', width: TEXT_LONG_LENGTH }} />
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content>
        <ListRowLoader />
      </Card.Content>
    </Card>
  );
}
